module.exports = __webpack_public_path__ + "images/porting-details.0f97dd19628207bead44e3ccf4ea181e.png";